import {
  catchFailure,
  flatMap,
  map,
  mapErrorPassThrough,
  pipe,
  succeed,
  trySync,
} from "@otto-ec/assets-core-utils/nano-effect";
import type { OcSheetV1Props } from "../SheetV1.types.g";

/**
 *
 */
const parseStringAsB64 = trySync(atob, mapErrorPassThrough<Error>);

/**
 *
 */
const parseJsonToSheetParams = trySync(JSON.parse<OcSheetV1Props>, mapErrorPassThrough<Error>);

/**
 *
 *
 *
 *
 *
 */
const sanitizeStringProps = (data: OcSheetV1Props): OcSheetV1Props => {
  const t = document.createElement("template");

  Object.keys(data).forEach((k) => {
    const key = k as keyof OcSheetV1Props;
    /*                                                                               */
    if (typeof data[key] !== "string") return;

    /*                                                                        */
    t.innerHTML = data[key];

    /*                                                                            */
    if (t.content.childElementCount < 1) return;

    /*                                                                              */
    data[key] = `${
      t.content.textContent
    }<!-- HTML content removed for security reasons -->` as never;
  });
  return data;
};

/**
 *
 *
 *
 *
 *
 */
export const parseSheetHashParamIntoIdOrProps = flatMap((paramValue: string) =>
  pipe(
    parseStringAsB64(paramValue),
    catchFailure(() => succeed(paramValue)),
    flatMap(parseJsonToSheetParams),
    map(sanitizeStringProps),
    catchFailure(() => succeed(paramValue)),
  ),
);

/**
 *
 *
 *
 *
 *
 *
 */
export const makeSheetPropsWithoutOpen = (
  ...props: (Partial<OcSheetV1Props> | undefined | null)[]
): Omit<Partial<OcSheetV1Props>, "open"> => {
  const result = Object.assign({}, ...props);
  /*                                                                        */
  /*                                 */
  delete result.open;
  return result;
};
